const state = {
  active: false
};

const getters = {
  getSummaryPageOptionActive: state => {
    return state.active;
  },
  getIsSummaryPageOptionUsed: (state, getters) => {
    return [
      "upload_personalization_fullpage_configuration",
      "upload_fullpage_configuration",
      "personalization_fullpage_configuration"
    ].includes(getters.getProductType);
    //return getters.getConfig.show_matrix;
  }
};

const mutations = {
  setSummaryPageOptionActive: (state, payload) => {
    state.active = payload;
  }
};

const actions = {
  setSummaryPageOptionActive: ({ commit }, payload) => {
    commit("setSummaryPageOptionActive", payload);
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
